import { Alert } from "antd"
import React from "react"
import { useTranslation } from "react-i18next"

import { useDatevOnlineError } from "Shared/hooks/company.hooks"

const DatevOnlineErrorBanner: React.FC = () => {
    const { t } = useTranslation()
    const datevOnlineError = useDatevOnlineError()

    if (!datevOnlineError) return null

    return (
        <Alert
            message={<span className="font-bold">{t(`info:datev_online_error.title`)}</span>}
            description={t(`info:datev_online_error.${datevOnlineError?.toLowerCase()}`)}
            type="error"
            showIcon={true}
        />
    )
}

export default DatevOnlineErrorBanner
